import IntegrationPathSettingCard from './integrationPathSettingCard.container';

export default IntegrationPathSettingCard;